export type HotelImageLike = {
  id?: string | number;
  url?: string;
  image?: string;
  href?: string;
  caption?: string;
  main_image?: boolean;
  links?: Record<string, { href?: string } | undefined>;
};

function isPlainObject(value: unknown): value is Record<string, any> {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

export function getHotelImageUrl(image: unknown): string | undefined {
  if (typeof image === "string") return image || undefined;
  if (!isPlainObject(image)) return undefined;

  const path =
    typeof image.path === "string" ? image.path.replace(/^\/+/, "") : "";
  return (
    image.url ||
    image.image ||
    image.href ||
    image.links?.["1000px"]?.href ||
    image.links?.["350px"]?.href ||
    image.links?.["200px"]?.href ||
    (path ? `https://images.grnconnect.com/${path}` : undefined)
  );
}

function imageSourcesFrom(value: unknown): HotelImageLike[] {
  if (!value) return [];
  if (typeof value === "string") return [{ url: value, main_image: true }];
  if (Array.isArray(value)) return value.filter(Boolean) as HotelImageLike[];
  if (!isPlainObject(value)) return [];

  if (Array.isArray(value.regular)) return value.regular.filter(Boolean);
  if (Array.isArray(value.images)) return value.images.filter(Boolean);
  if (getHotelImageUrl(value)) return [value as HotelImageLike];

  return [];
}

export function collectHotelImages(hotel: any): HotelImageLike[] {
  const rawImages = [
    ...imageSourcesFrom(hotel?.hotel_images),
    ...imageSourcesFrom(hotel?.hotel_image),
    ...imageSourcesFrom(hotel?.images),
    ...imageSourcesFrom(hotel?.image),
  ];

  const seen = new Set<string>();
  return rawImages
    .filter((image) => {
      const url = getHotelImageUrl(image);
      if (!url || seen.has(url)) return false;
      seen.add(url);
      return true;
    })
    .sort(
      (left, right) =>
        Number(Boolean(right.main_image)) - Number(Boolean(left.main_image))
    );
}
